import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
var fileDownload = require("js-file-download");
import { request } from "@/js/http/http_request";
import { hasRole, getClientAppData } from "@/js/http/auth.js";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { getFullNameUser } from "@/js/user/user.js";
import { stockTypes, stockStatus, defaultPagingChoices, bottlings, stockReservationTypes, emptyCellContent } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import WorldMap from "@/components/external/WorldMap.vue";
import StockReconciliationDialog from "@/components/stock/StockReconciliationDialog.vue";
import StockCommittedDialog from "@/components/stock/StockCommittedDialog.vue";
import StockTransferDomesticListModal from "@/components/stock/StockTransferDomesticListModal.vue";
import WarehouseStockTransferModal from "@/components/stock/WarehouseStockTransferModal.vue";
import StockExportDrawer from "@/components/stock/StockExportDrawer.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "StockList",
  components: {
    StockReconciliationDialog: StockReconciliationDialog,
    StockCommittedDialog: StockCommittedDialog,
    paging: pagingComponent,
    index: indexComponent,
    Confirm: Confirm,
    WorldMap: WorldMap,
    StockTransferDomesticListModal: StockTransferDomesticListModal,
    WarehouseStockTransferModal: WarehouseStockTransferModal,
    StockExportDrawer: StockExportDrawer,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      clientAppData: null,
      isEnvDevelopment: false,
      canManage: false,
      canManageDomesticTransfers: false,
      baseModel: {
        stocks: [],
        numberOfStocks: 0,
        numberOfPages: 0
      },
      isAdvancedFilterOpened: false,
      searchCriterias: {
        label: "",
        type: null,
        vintage: null,
        id_country: null,
        id_wine: null,
        warehouseIds: null,
        intendedCountryIds: null,
        minQuantityAvailable: 1,
        warehouseDefaultDepartureIds: null,
        reservationType: null,
        lowStockAlertType: null,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      },
      stockReconciliationShown: false,
      dialogWorldMap: false,
      markers: [],
      drawer: false,
      selectedMarker: {
        country: null,
        items: []
      },
      datatable_loading: true,
      datatable_selected: [],
      datatable_headers: [{
        text: "Ref. warehouse",
        value: "reference_warehouse",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Producer",
        value: "producer",
        align: "center",
        width: "300px"
      }, {
        text: "Appellation",
        value: "appellation",
        align: "center",
        width: "300px"
      }, {
        text: "Vintage",
        value: "vintage",
        align: "center"
      }, {
        text: "Bottling",
        value: "bottling",
        align: "center"
      }, {
        text: "Casing",
        value: "casing",
        align: "center"
      }, {
        text: "Available",
        value: "qty",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Committed",
        value: "qty_committed",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Storage",
        value: "warehouse_name",
        align: "center"
      }, {
        text: "Intended countries",
        value: "for",
        align: "center",
        width: "200px"
      }, {
        text: "Consolidation for order",
        value: "warehouse_departure_name",
        align: "center"
      }, {
        text: "Reservation",
        value: "reservation",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false
      }],
      datatable_items: [],
      errorMessages: {
        criteria: {
          format: "The criterias are incorrect"
        }
      },
      isLoadingWines: false,
      wines: [],
      countries: [],
      stockTypesFilter: Object.entries(stockTypes).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return [].concat(_toConsumableArray(acc), [{
          value: key,
          label: value
        }]);
      }, []),
      dialogConfirmDelete: false,
      selectedId: null,
      confirmationLabel: "Do you want to delete the selected stock ?",
      confirmationTitle: "Delete",
      isExporting: false,
      stockCommittedShown: false,
      stockCommittedIdStock: 0,
      listWarehouses: [],
      isLoadingWarehouses: true,
      availableLowStockAlertTypes: [{
        id: "onlyWithLowStockAlert",
        name: "Low stock alert defined"
      }, {
        id: "onlyStocksInAlert",
        name: "Stock below low stock alert"
      }, {
        id: "onlyStocksNotInAlert",
        name: "Stock above low stock alert"
      }],
      stockTransfersList: {
        shown: false
      },
      warehouseStockTransfer: {
        shown: false
      },
      exportStockDrawer: false,
      stockTypes: stockTypes,
      stockStatus: stockStatus,
      pagingLimitsChoices: defaultPagingChoices,
      stockReservationTypes: stockReservationTypes,
      emptyCellContent: emptyCellContent,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAdvancedFiltering: function isAdvancedFiltering() {
      var _this$searchCriterias, _this$searchCriterias2;
      return this.searchCriterias.minQuantityAvailable != 1 || ((_this$searchCriterias = this.searchCriterias.warehouseDefaultDepartureIds) === null || _this$searchCriterias === void 0 ? void 0 : _this$searchCriterias.length) > 0 || ((_this$searchCriterias2 = this.searchCriterias.intendedCountryIds) === null || _this$searchCriterias2 === void 0 ? void 0 : _this$searchCriterias2.length) > 0 || this.searchCriterias.reservationType !== null || this.searchCriterias.lowStockAlertType !== null;
    },
    availableStockReservationTypes: function availableStockReservationTypes() {
      return Object.values(this.stockReservationTypes);
    },
    hasResult: function hasResult() {
      return !this.datatable_loading && this.baseModel.numberOfStocks > 0;
    },
    canManageCogs: function canManageCogs() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_COGS);
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$$route$query;
      var _this, response, _this2$$route$query2, filters;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.isEnvDevelopment = process.env.NODE_ENV === "development";
            _this2.clientAppData = getClientAppData(_this2);
            _this2.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK);
            _this2.canManageDomesticTransfers = hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK_DOMESTIC_TRANSFERS);
            if (_this2.canManageCogs) {
              _this2.datatable_headers.splice(6, 0, {
                text: "COGS",
                value: "cogs_euro_ex_vat",
                align: "center",
                cellClass: "text-nowrap"
              });
            }
            _this = _this2;
            _context.next = 8;
            return request("/v1/countries?implantedMarket=true", "post", _this2.clientAppData, false, "api").catch(function (e) {
              var errorData = getErrorData(e, _this.managedExceptions);
              handleErrorData(_this, errorData);
            });
          case 8:
            response = _context.sent;
            _this2.countries = _toConsumableArray(response.data.countries);
            _this2.fetchWines();
            _context.next = 13;
            return _this2.fetchWarehouses();
          case 13:
            if ((_this2$$route$query = _this2.$route.query) !== null && _this2$$route$query !== void 0 && _this2$$route$query.id_wine) {
              _this2.searchCriterias.id_wine = +((_this2$$route$query2 = _this2.$route.query) === null || _this2$$route$query2 === void 0 ? void 0 : _this2$$route$query2.id_wine);
              _this2.$router.replace({
                name: _this2.$route.name
              });
            } else {
              filters = getFilters();
              if (filters !== null && filters !== void 0 && filters.stocks) {
                _this2.searchCriterias = _objectSpread({}, filters.stocks);
              }
            }
            _this2.search();
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    openExportStockDrawer: function openExportStockDrawer() {
      this.exportStockDrawer = true;
    },
    exportStocks: function exportStocks() {
      var _this = this;
      _this.isExporting = true;
      request("/v1/stocks/export/", "get", null, true, "api", "blob").then(function (response) {
        _this.isExporting = false;
        fileDownload(response.data, "PLATFORM_STOCKS_LIST.xlsx", "application/xlsx");
      }).catch(function (e) {
        _this.isExporting = false;
        var errorData = getErrorData(e, _this.managedExceptions);
        handleErrorData(_this, errorData);
      });
    },
    clearFilters: function clearFilters() {
      this.searchCriterias = _objectSpread(_objectSpread({}, this.searchCriterias), {}, {
        label: "",
        type: null,
        vintage: null,
        id_country: null,
        id_wine: null,
        warehouseIds: null,
        intendedCountryIds: null,
        minQuantityAvailable: 1,
        warehouseDefaultDepartureIds: null,
        reservationType: null,
        lowStockAlertType: null,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      });
      this.search(true);
    },
    openReconcileStocks: function openReconcileStocks() {
      this.stockReconciliationShown = true;
    },
    showCommittedDetails: function showCommittedDetails(idStock) {
      this.stockCommittedIdStock = idStock;
      this.stockCommittedShown = true;
    },
    closeCommittedDetails: function closeCommittedDetails() {
      this.stockCommittedIdStock = null;
      this.stockCommittedShown = false;
    },
    search: function search() {
      var _this3 = this;
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$EventBus.$emit("loading", true);
      var _this = this;
      document.body.style.cursor = "wait";
      _this.datatable_loading = true;
      _this.loadingSearch = true;
      if (isResetPaging) _this.searchCriterias.paging.askedPage = 0;
      setFilters(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          stocks: _this3.searchCriterias
        });
      });
      var requestFilters = _objectSpread({}, this.searchCriterias);
      delete requestFilters.lowStockAlertType;
      if (this.searchCriterias.lowStockAlertType !== null) {
        if (this.searchCriterias.lowStockAlertType === "onlyWithLowStockAlert") {
          requestFilters.hasLowStockAlert = true;
        } else if (this.searchCriterias.lowStockAlertType === "onlyStocksInAlert") {
          requestFilters.hasLowStockAlert = true;
          requestFilters.isInLowStockAlert = true;
        } else if (this.searchCriterias.lowStockAlertType === "onlyStocksNotInAlert") {
          requestFilters.hasLowStockAlert = true;
          requestFilters.isInLowStockAlert = false;
        }
      }
      request("/v1/stocks", "post", requestFilters, true, "api").then(function (response) {
        _this.datatable_items = [];
        response.data.stocks.forEach(function (stock) {
          var _stock$warehouse, _this$stockStatus$fil, _stock$stock_type, _stock$stock_type2;
          var item = {
            id_stock: stock.id_stock,
            reference_warehouse: stock.reference_warehouse,
            accountancy_code: stock.wine.accountancy_code,
            producer: stock.wine.producer.name,
            appellation: stock.wine.appellation,
            vintage: stock.wine.year,
            qty: stock.quantity,
            qty_committed: stock.quantity_committed > 0 ? stock.quantity_committed : null,
            cogs_euro_ex_vat: stock.wine.cogs_euro_ex_vat + " €",
            warehouse_name: (_stock$warehouse = stock.warehouse) === null || _stock$warehouse === void 0 ? void 0 : _stock$warehouse.name,
            warehouse_departure_name: stock.warehouse_default_departure.name,
            status: (_this$stockStatus$fil = _this.stockStatus.filter(function (ss) {
              return ss.value === stock.status;
            })[0]) === null || _this$stockStatus$fil === void 0 ? void 0 : _this$stockStatus$fil.label,
            bottling: bottlings.filter(function (x) {
              return x.value === stock.wine.bottling;
            }).map(function (x) {
              return x.text;
            }).shift(),
            casing: stock.wine.casings.find(function (wc) {
              return wc.isDefault;
            }).casingId,
            for: stock.countries.length === stock.total_implanted_countries ? "All" : stock.countries.map(function (x) {
              return x.name;
            }).join(", ")
          };
          if (((_stock$stock_type = stock.stock_type) === null || _stock$stock_type === void 0 ? void 0 : _stock$stock_type.toLowerCase()) === "stock") {
            item.type = "Stock";
          } else if (((_stock$stock_type2 = stock.stock_type) === null || _stock$stock_type2 === void 0 ? void 0 : _stock$stock_type2.toLowerCase()) === "consignment") {
            item.type = "Direct Producer";
          }
          if (stock.reservation_type === stockReservationTypes.SPECIFIC_CUSTOMER.id) {
            item.reservation = getFullNameUser(stock.reservation_user);
          } else if (stock.reservation_type === stockReservationTypes.SPECIFIC_CONSULTANT.id) {
            item.reservation = getFullNameUser(stock.reservation_consultant);
          } else {
            item.reservation = Object.values(stockReservationTypes).find(function (x) {
              return x.id === stock.reservation_type;
            }).shortListLabel;
          }
          item.hasLowStockAlert = stock.hasLowStockAlert;
          item.lowStockAlertQuantity = stock.lowStockAlertQuantity;
          _this.datatable_items = [].concat(_toConsumableArray(_this.datatable_items), [item]);
        });

        // Finished loading
        _this.datatable_loading = false;
        _this.baseModel = {
          stocks: response.data.stocks,
          numberOfStocks: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / +_this.searchCriterias.paging.limits)
        };
        _this.searchCriterias.paging.currentPage = _this.searchCriterias.paging.askedPage + 1;
        if (!_this.searchCriterias.paging.currentPage) {
          _this.searchCriterias.paging.currentPage = 0;
        }
        _this.loadingSearch = false;
        document.body.style.cursor = "default";
        _this.$EventBus.$emit("loading", false);
        _this.initMap();
      });
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.search();
        window.scrollTo(0, 0);
      }
    },
    stockDetails: function stockDetails(idStock) {
      var data = {
        name: "adminStockDetails"
      };
      if (idStock > 0) {
        data.query = {
          id_stock: idStock
        };
      }
      this.$router.push(data);
    },
    showConfirmDelete: function showConfirmDelete(idStock) {
      var _this = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to close this stock ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          request("/v1/stock/" + idStock, "delete", null, true, "api").then(function (_) {
            _this.search();
          }).catch(function (e) {
            var errorData = getErrorData(e, _this.managedExceptions, "Unable to close the stock", true);
            handleErrorData(_this, errorData);
          });
        }
      });
    },
    rowClicked: function rowClicked(row) {
      this.stockDetails(row.id_stock, false);
    },
    toggleWordMap: function toggleWordMap() {
      var _this = this;
      _this.dialogWorldMap = !_this.dialogWorldMap;
    },
    initMap: function initMap() {
      var _this = this;
      _this.countries.forEach(function (country) {
        _this.markers.push({
          position: {
            lat: country.latitude,
            lng: country.longitude,
            iso: country.iso_2,
            id_country: country.id_country,
            name: country.printable_name
          }
        });
      });
    },
    selectMarker: function selectMarker(name_country, iso_country, id_country) {
      var _this = this;
      var stocks = _this.baseModel.stocks;
      _this.selectedMarker.items = [];
      _this.drawer = true;
      _this.selectedMarker.country = name_country;
      stocks.forEach(function (stock) {
        stock.countries.forEach(function (country) {
          if (country.id_country == id_country) {
            if (_this.selectedMarker.items.indexOf(stock) === -1) {
              _this.selectedMarker.items.push(stock);
            }
          }
        });
      });
    },
    fetchWines: function fetchWines() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isLoadingWines = true;
              _this = _this4;
              _context2.next = 4;
              return request("/v1/stock?wines=true", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get wines.", true);
                handleErrorData(_this, errorData);
                _this.isLoadingWines = false;
              });
            case 4:
              response = _context2.sent;
              if (response) {
                _this4.wines = response.data.wines.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                  });
                });
              }
              _this4.isLoadingWines = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchWarehouses: function fetchWarehouses() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this5;
              _this.isLoadingWarehouses = true;
              _context3.next = 4;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get warehouses.", true);
                handleErrorData(_this, errorData);
                _this.isLoadingWarehouses = false;
              });
            case 4:
              response = _context3.sent;
              _this5.listWarehouses = _toConsumableArray(response.data.warehouses);
              _this5.isLoadingWarehouses = false;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openStockTransfersList: function openStockTransfersList() {
      var _this6 = this;
      this.stockTransfersList.shown = true;
      this.$nextTick(function () {
        _this6.$refs.stockTransfersList.open();
      });
    },
    closeStockTransfersList: function closeStockTransfersList() {
      this.stockTransfersList.shown = false;
    },
    openWarehouseStockTransfer: function openWarehouseStockTransfer() {
      var _this7 = this;
      this.warehouseStockTransfer.shown = true;
      this.$nextTick(function () {
        _this7.$refs.warehouseStockTransfer.open();
      });
    },
    closeWarehouseStockTransfer: function closeWarehouseStockTransfer() {
      this.warehouseStockTransfer.shown = false;
    },
    filterIntegerKey: filterIntegerKey,
    filterVAutocomplete: filterVAutocomplete
  }
};